import WhatsAppIcon from "@/components/icons/WhatsAppIcon";
import { COMPANY } from "@/data/clientsData";

const WhatsAppFloat = () => {
  const number = COMPANY.whatsapp.replace(/\D/g, "");
  const message = encodeURIComponent(
    "Hi Stagehook Global — I'd like a quote for my next expo."
  );
  return (
    <a
      href={`https://wa.me/${number}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat with us on WhatsApp"
      className="whatsapp-float"
    >
      <span className="whatsapp-float__ring" aria-hidden="true" />
      <WhatsAppIcon size={30} className="whatsapp-float__icon" />
      <span className="whatsapp-float__label">Chat</span>
    </a>
  );
};

export default WhatsAppFloat;
